import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const OnlineOrderingSection = () => {
  const [isOrderMenuOpen, setIsOrderMenuOpen] = useState(false);

  const handleOrderLocation = (location) => {
    if (location === 'durham') {
      window.open('https://online.skytab.com/d532ef127b6d5a39d4172cf8121d87bf', '_blank');
    } else if (location === 'chapel-hill') {
      window.open('https://online.skytab.com/5a689c513d0e59a5cb701768602d0256', '_blank');
    }
    setIsOrderMenuOpen(false);
  };

  return (
    <section className="py-16 bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <div className="inline-flex items-center space-x-2 bg-accent/10 px-4 py-2 rounded-full mb-6">
            <Icon name="ShoppingBag" size={20} className="text-accent" />
            <span className="text-accent font-body font-medium">ORDER ONLINE</span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-6">
            Craving Kahlovera? Order Now
          </h2>

          <p className="text-lg text-primary-foreground/90 font-body mb-8 max-w-2xl mx-auto">
            Skip the wait and order online for pickup or delivery. Your favorite dishes are just a few clicks away.
          </p>

          <div className="relative inline-block">
            <Button
              onClick={() => setIsOrderMenuOpen(!isOrderMenuOpen)}
              className="bg-accent text-accent-foreground hover:bg-accent/90 px-10 py-4 text-lg font-semibold rounded-lg shadow-warm-lg hover:shadow-warm-xl transition-all duration-300 flex items-center space-x-2"
            >
              <span>Order Now</span>
              <Icon name="ChevronDown" size={20} className={`transition-transform duration-200 ${isOrderMenuOpen ? 'rotate-180' : ''}`} />
            </Button>

            {isOrderMenuOpen && (
              <>
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setIsOrderMenuOpen(false)}
                />
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-56 bg-card border border-border rounded-lg shadow-warm-lg overflow-hidden z-50">
                  <button
                    onClick={() => handleOrderLocation('durham')}
                    className="w-full px-6 py-4 text-left text-sm font-body font-medium text-foreground hover:bg-muted hover:text-primary transition-colors duration-200 flex items-center justify-between"
                  >
                    <span>Durham</span>
                    <Icon name="ExternalLink" size={16} className="text-muted-foreground" />
                  </button>
                  <div className="border-t border-border"></div>
                  <button
                    onClick={() => handleOrderLocation('chapel-hill')}
                    className="w-full px-6 py-4 text-left text-sm font-body font-medium text-foreground hover:bg-muted hover:text-primary transition-colors duration-200 flex items-center justify-between"
                  >
                    <span>Chapel Hill</span>
                    <Icon name="ExternalLink" size={16} className="text-muted-foreground" />
                  </button>
                </div>
              </>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default OnlineOrderingSection;